// The app's two live regions (PARITY P255): «polite» for new messages in the open conversation,
// «assertive» for a send that failed. Mounted once (Workspace); anything may call `announce`.
// Clearing first and setting a beat later makes a repeated sentence be read again.
import { useSyncExternalStore } from 'react';

type Politeness = 'polite' | 'assertive';
const text: Record<Politeness, string> = { polite: '', assertive: '' };
const listeners = new Set<() => void>();
let version = 0;

function emit(): void {
  version++;
  for (const l of listeners) l();
}

export function announce(message: string, politeness: Politeness = 'polite'): void {
  if (!message) return;
  text[politeness] = '';
  emit();
  setTimeout(() => {
    text[politeness] = message;
    emit();
  }, 60);
}

/** What the regions say now (tests and the a11y e2e read it). */
export function announced(): { polite: string; assertive: string } {
  return { ...text };
}

export function LiveRegions() {
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => version,
  );
  return (
    <>
      <div className="visually-hidden" role="status" aria-live="polite" aria-atomic="true" data-live="polite">
        {text.polite}
      </div>
      <div className="visually-hidden" role="alert" aria-live="assertive" aria-atomic="true" data-live="assertive">
        {text.assertive}
      </div>
    </>
  );
}
